import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';

const Input = styled('input')({
    display: 'none',
});

export default function UploadButtons() {
const [previewimage, setFileImg] = useState("");
const [image, setImage] = useState("");
const [showImage,setShowImage]   = useState(true);
const [showVid,setShowVid]   = useState(false);
const [showAudio,setShowAudio]   = useState(false);

const getImage = (e) => {
   let ext = e.target.files[0].type.split('/')[0];

    if(ext == 'image'){
        setShowImage(true);
        setShowAudio(false);
        setShowVid(false);
    }else if(ext == 'video'){
        setShowVid(true);
        setShowImage(false);
        setShowAudio(false);
    }else if(ext == 'audio'){
        setShowAudio(true);
        setShowVid(false);
        setShowImage(false);
    }
    if (e.target.files && e.target.files.length > 0) setFileImg(e.target.files[0]);
};

useEffect(() => {
    if (previewimage?.length < 1) return;
    const newImages = URL.createObjectURL(previewimage);
    setImage([newImages]);
}, [previewimage]);

    return (
        <Box className='live_upload'>
            <Typography variant='h2'>  Upload File </Typography>
            <Typography variant='h6'>
            Image, Video, Audio,
            </Typography>
            <Typography variant='h6' fontSize='15px' lineHeight='22px' letterSpacing='0.3px' paddingBottom='5px' color='#686464'>File types supported: JPG, PNG, GIF, SVG, MP4, MP3. Max size: 100 MB</Typography>
            <Stack direction="row" alignItems="center" spacing={2} className='drags'> 
                <label htmlFor="contained-button-file">
                <Input accept="image/*,video/*,audio/*" id="contained-button-file" onChange={getImage}
                    name='image' type="file" />
                   {showImage && image.length> 0 && <img className='up_lod' src={image} alt='' />} 
                   {showVid && <video width="320" height="240" controls autoplay loop className='up_lod' src={image} alt=''>
                     <source src={image} type="video/mp4" />  
                    </video>}
                    {showAudio && 
                    <audio controls>
                        <source src={image}  />                   
                    </audio>
                    }
                    {image.length == 0 && <img className='' src="./img/upload-icon.png" alt='' /> }<br></br>Upload

                </label>
            </Stack>
        </Box>
    );
}
